import {
  AppShellBanner,
  AppShellTopInset,
} from "@sylviq/ui-react-web/components/shell/AppShellTopInset";
import { ThemeCanvas } from "@sylviq/ui-react-web/components/ui/ThemeCanvas";
import { RouterProvider } from "@tanstack/react-router";
import { isFullStackTestMode, isUiFixtureMode } from "@/lib/dev-mode";
import { SessionProvider } from "@/lib/session";
import { SuiOperationsHost } from "@/lib/sui-operations";
import { OrganizationProvider } from "@/lib/organization";
import { router } from "@/routes/router";

function DevModeBanner() {
  if (!isUiFixtureMode && !isFullStackTestMode) return null;
  const label = isUiFixtureMode
    ? "UI fixture mode — sample data only; changes stay in memory"
    : "Local full-stack mode — local API and database";
  return (
    <AppShellBanner>
      <span>{label}</span>
      {isFullStackTestMode ? (
        <a
          className="underline underline-offset-2"
          href={`/onboarding${window.location.search}`}
        >
          Set up this local organization
        </a>
      ) : null}
    </AppShellBanner>
  );
}

export function App() {
  return (
    <ThemeCanvas
      data-niche-test-mode={
        isUiFixtureMode ? "ui" : isFullStackTestMode ? "fullstack" : undefined
      }
    >
      <AppShellTopInset>
        <DevModeBanner />
      </AppShellTopInset>
      <SessionProvider>
        <OrganizationProvider>
          <SuiOperationsHost>
            <RouterProvider router={router} />
          </SuiOperationsHost>
        </OrganizationProvider>
      </SessionProvider>
    </ThemeCanvas>
  );
}
